import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import Overlay from '../../Overlay';
import { useLightboxContext } from '../LightboxContext';
import { LightboxBackdropProps } from '../types';

const LightboxBackdrop = ({ children, overlayTestId }: LightboxBackdropProps) => {
  const { close } = useLightboxContext();

  return (
    <Container position="relative" zIndex="overlay">
      <Overlay zIndex="-1" dataTestId={overlayTestId} onClick={close} opacity="high" />
      <Container
        position="fixed"
        top={0}
        right={0}
        bottom={0}
        left={0}
        margin="auto"
        width="fit-content"
        height="fit-content"
      >
        {children}
      </Container>
    </Container>
  );
};

LightboxBackdrop.displayName = 'LightboxBackdrop';

export default LightboxBackdrop;
